import gql from 'graphql-tag';
import { notification } from './fragments';

export const NOTIFICATION_RECEIVED = gql`
  ${notification}
  subscription NotificationReceived {
    notificationReceived {
      notification {
        ...notification
      }
    }
  }
`;

export const NOTIFICATION_UPDATED = gql`
  ${notification}
  subscription NotificationUpdated {
    notificationUpdated {
      notification {
        ...notification
      }
    }
  }
`;

export const NOTIFICATION_DELETED = gql`
  subscription NotificationDeleted {
    notificationDeleted {
      notificationId
    }
  }
`;
